import React from "react";
import { Formik, Form } from "formik";
import { sendContactForm } from "./contactService";
import * as Yup from "yup";
import Input from "./Input";
import Icon from "./Icon";

const schema = Yup.object().shape({
  name: Yup.string().required("Името е задължително."),
  email: Yup.string()
    .email("Невалиден имейл.")
    .required("Имейлът е задължителен."),
  phone: Yup.string().required("Тел. номер е задължителен."),
});

function ContactForm({
  className = "flex flex-col items-start w-full md:mx-auto",
  formName,
}) {
  return (
    <div className="w-full lg:w-3/5">
      <Formik
        initialValues={{ name: "", phone: "", email: "", message: "" }}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          values.formName = formName;
          sendContactForm(values)
            .then(() => {
              actions.resetForm();
            })
            .catch((err) => {})
            .finally(() => actions.setSubmitting(false));
        }}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form
            name={formName}
            netlify="true"
            data-netlify={true}
            className={`${className} gap-2`}
          >
            <Input type="hidden" name="bot-field" />
            <Input
              type="text"
              name="name"
              placeholder="Име *"
              autocomplete="off"
            />
            <Input type="email" name="email" placeholder="Имейл *" />

            <Input type="text" name="phone" placeholder="Тел. номер *" />
            <Input
              type="text"
              component="textarea"
              name="message"
              placeholder="Съобщение"
            />
            <button className="w-full bg-black text-white text-center flex items-center gap-2 justify-center rounded-full py-4 mt-2 cursor-pointer group hover:scale-[102%] transition-all duration-300" type="submit" disabled={isSubmitting}>
              Изпрати
              <Icon iconName="chevronRight" className="w-6 h-6 transform transition-transform duration-300 group-hover:translate-x-1"/>
            </button>
            {errors.name && touched.name ? (
              <p
                className="text-sm text-red-400 mt-1"
                name="name"
                component="div"
              >
                {errors.name}
              </p>
            ) : null}
            {errors.email && touched.email ? (
              <p
                className="text-sm text-red-400 mt-1"
                name="email"
                component="div"
              >
                {errors.email}
              </p>
            ) : null}
            {errors.phone && touched.phone ? (
              <p
                className="text-sm text-red-400 mt-1"
                name="phone"
                component="div"
              >
                {errors.phone}
              </p>
            ) : null}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ContactForm;
